import styled, { css } from 'styled-components';

interface ContainerProps {
  isOpen: boolean;
  isMobile: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: grid;
  ${({ isMobile }) => isMobile
    ? css`
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto auto;

      grid-template-areas: 
      "banner" 
      "description" 
      "filter" 
      "plans";
    `
    : css`
      grid-template-columns: 1fr 3fr;
      grid-template-rows: auto auto auto auto;
    `
  }

  ${({ isOpen, isMobile }) => {
    if (isOpen && !isMobile) {
      return css`
        grid-template-areas: 
        "banner banner" 
        "description description" 
        "filter plans";
      `;
    }

    if (!isOpen && !isMobile) {
      return css`
        grid-template-areas: 
        "banner banner" 
        "description description" 
        "plans plans";
      `;
    }
  }}
`;
